import { axiosConfig } from '../api/axios-config.js'

// CaringCM 機構設定
export const caringcm = {
  // 取得清單
  get: (token) => axiosConfig.get('/api/caringcm/institutions', token),

  // 取得單筆（含明文帳號）
  show: (id, token) => axiosConfig.get(`/api/caringcm/institutions/${id}`, token),

  // 新增
  create: (data, token) => axiosConfig.post('/api/caringcm/institutions', data, token),

  // 更新
  update: (id, data, token) => axiosConfig.patch(`/api/caringcm/institutions/${id}`, data, token),

  // 刪除
  delete: (id, token) => axiosConfig.delete(`/api/caringcm/institutions/${id}`, token),

  // 切換啟用/停用
  toggle: (id, token) => axiosConfig.patch(`/api/caringcm/institutions/${id}/toggle`, {}, token),

  // 連線測試
  testConnection: (token) => axiosConfig.post('/api/caringcm/test-connection', {}, token)
}
